import { FormEvent, ReactNode } from 'react'
import cx from 'classnames'

import Button, {
  ButtonColor,
  ButtonSize,
  ButtonVariant,
} from '@components/buttons/button'

interface AlertProps {
  children: ReactNode
  onClick?: (e: FormEvent) => void
  buttonText?: string
  buttonVariant?: ButtonVariant
  buttonColor?: ButtonColor
  className?: string
  error?: boolean
  success?: boolean
}

const Alert = ({
  children,
  onClick,
  buttonText,
  buttonVariant = ButtonVariant.OUTLINED,
  buttonColor = ButtonColor.DEFAULT,
  className,
  error,
  success,
}: AlertProps) => {
  return (
    <div
      className={cx(
        'p-4 text-center border rounded-md',
        {
          'bg-transparent border-current text-current': !error && !success,
          'text-success bg-success-bg border-success': success,
          'text-error bg-error-bg border-error': error,
        },
        className
      )}
    >
      {children}
      {onClick && buttonText && (
        <div className="mt-4">
          <Button
            variant={buttonVariant}
            color={buttonColor}
            size={ButtonSize.SMALL}
            onClick={onClick}
          >
            {buttonText}
          </Button>
        </div>
      )}
    </div>
  )
}

export default Alert
